import React from 'react'
import { Form, Icon, Input, Button, Row, Col, DatePicker } from 'antd'
import moment from 'moment'

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

export const ValidationFormStep2 = (props) => {

    var validationExistsText;

    if (props.currentStep !== 'Step 2') {
      return null
    }
    return(
        <div className="form-group">

            <h3 style={{ display: 'inline-block !important' }}>Subject Found! Please verify details below:</h3>

            <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>

            <hr />
            <p> </p>
            <h3 style={{  display: 'inline-block !important' }}>Randomization Information</h3>

            <h4 style={{  display: 'inline-block !important' }}>Randomization Date: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.randomizationDate}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject Weight: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.randomizationWeight} kg</span></h4>


            <h4 style={{  display: 'inline-block !important' }}>Randomization Drug: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.randomizationGroup === 'tpa' ? 'Alteplase tPA' : 'Tenecteplase tNK'}</span></h4>
            {props.randomizationGroup === 'tnk_tpa' ?
                <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Tenecteplase tNK Randomization Dose: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.randomizationTNKDose}</span></h4>
                :
                <div>
                    <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Alteplase tPA Randomization Bolus Dose: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.randomizationTPABolusDose}</span></h4>
                    <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Alteplase tPA Randomization Infusion Dose: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.randomizationTPAInfusionDose}</span></h4>
                </div>
            }

            <hr />
            <p> </p>
            <h3 style={{  display: 'inline-block !important' }}>Consent Information</h3>

            <h4 style={{  display: 'inline-block !important' }}>Consent Exists: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                {props.consentExists === true ? <div>Yes</div> : <div>No</div> }
            </span></h4>


            <hr />
            <p> </p>
            <h3 style={{  display: 'inline-block !important' }}>Validation Information</h3>

            <h4 style={{  display: 'inline-block !important' }}>Validation Exists: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                {props.validationExists === true ? <div>Yes</div> : <div>No</div> }
            </span></h4>

            {
              (() => {

                if (props.validationExists) {
                    return (
                        <div className="validation-exists">
                            <h4 style={{  display: 'inline-block !important' }}>Validation Date: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsDate}</span></h4>
                            <h4 style={{  display: 'inline-block !important' }}>Drug allocated as per randomization administered: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                                {props.validationExistsUsedRecommendedValues === true ? <div>Yes</div> : <div>No</div> }
                            </span></h4>

                            { props.validationExistsUsedRecommendedValues === true ?
                                <div>&nbsp;</div>

                                :

                                <div>
                                    <h4 style={{  display: 'inline-block !important' }}>Validation Weight: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsWeight} kg</span></h4>

                                    <h4 style={{  display: 'inline-block !important' }}>Validation Drug: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsGroup === 'tpa' ? 'Alteplase tPA' : 'Tenecteplase tNK'}</span></h4>
                                    {props.validationExistsGroup === 'tnk_tpa' ?
                                        <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Validation Dose: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsTNKDose}</span></h4>
                                        :
                                        <div>
                                            <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Validation Bolus Dose: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsTPABolusDose}</span></h4>
                                            <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Validation Infusion Dose: <span className='bigger' style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsTPAInfusionDose}</span></h4>
                                        </div>
                                    }
                                </div>

                            }

                            <h4 style={{  display: 'inline-block !important' }}>Validation Comments: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsComments}</span></h4>


                            <hr />
                            <p> </p>
                            <h3 style={{  display: 'inline-block !important' }}>Vial Information</h3>

                            <h4 style={{  display: 'inline-block !important' }}>Vial Number: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsVialNumber}</span></h4>
                            <h4 style={{  display: 'inline-block !important' }}>Vial Expiry Date: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsVialExpiryDate}</span></h4>

                        </div>
                    );
                }

              })()
            }

            <hr />
            <p> </p>
            <h3 style={{  display: 'inline-block !important' }}>Deviation Details</h3>

            <h4 style={{  display: 'inline-block !important' }}>Any other protocol deviation(s) occurred: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                {props.validationExistsDeviationOccurred === true ? <div>Yes</div> : <div>No</div> }
            </span></h4>
            { props.validationExistsDeviationOccurred === true ?
                <h4 style={{  display: 'inline-block !important' }}>Deviation Comments: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationDeviationExistsComments}</span></h4>
                :
                null
            }
            

            <hr />
            <br/>
            <h3 style={{  display: 'inline-block !important' }}>SAE Information</h3>

            <h4 style={{  display: 'inline-block !important' }}>SAE exists: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.saeExists === true ? 'Yes' : props.saeExists === false ? 'No' : 'Not entered'}</span></h4>

            <hr />
            <p> </p>
            <h3 style={{  display: 'inline-block !important' }}>Validation Options</h3>

            <Form.Item>
                {props.getFieldDecorator('validationExistsUsedRecommendedValues', {
                    initialValue: '',
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Was the drug allocated as per randomization administered?'
                    }],
                })(
                  <label>
                    <h5>
                    Was the drug allocated as per randomization administered?
                    </h5>
                      <select id="validationExistsUsedRecommendedValues" name="validationExistsUsedRecommendedValues" autoFocus size="large" className="ant-input ant-input-lg">
                        <option value="">Please select an option</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                  </label>
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('validationExistsDeviationOccurred', {
                    initialValue: '',
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Did any other protocol deviation(s) occur?'
                    }],
                })(
                  <label>
                    <h5>
                    Did any other protocol deviation(s) occur?
                    </h5>
                      <select id="validationExistsDeviationOccurred" name="validationExistsDeviationOccurred" autoFocus size="large" className="ant-input ant-input-lg">
                        <option value="">Please select an option</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                  </label>
                )}
            </Form.Item>


            <Form.Item>
                {props.getFieldDecorator('validationOverwrite', {
                    initialValue: props.validationOverwrite,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'You need to agree to override data if you wish to proceed with this entry!'
                    }],
                })(
                  <label>
                    <h5>
                    Overwrite existing validation data, if it exists?
                    </h5>
                      <select id="validationOverwrite" name="validationOverwrite" size="large" className="ant-input ant-input-lg">
                        <option value="">Overwrite Validation Data?</option>
                        <option value="yes">Yes</option>
                        <option value="">No</option>
                      </select>
                  </label>
                )}
            </Form.Item>




       </div>

    );
}



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/Step2.js